export default "__VITE_ASSET__oqbFUQOK__"